module.exports = __webpack_public_path__ + "static/media/portfolio-details-3.1db30585.jpg";